import SEO from "../../../data/seo";
import HeaderTwo from "../../../layout/headers/header-two";
import BreadCrumb from "../../common/breadcrumb";
import FooterOne from "../../../layout/footers/footer-one";
import TwoColumns from "./two-columns";

const PortfolioTwoColumns = () => {
    return (
        <>
            <SEO pageTitle="Featured Showcase | Arclight Developers" />
            <HeaderTwo />
            {/* Renamed the breadcrumb to match your new professional Gallery naming */}
            <BreadCrumb title="Featured Showcase" innerTitle="Featured Showcase" />
            <TwoColumns />
            <FooterOne />    
        </>
    );
};

export default PortfolioTwoColumns;